import { useGlobalInitData } from "src/contexts/GlobalInitDataContext.ts";
import { useStoredState } from "src/utils/useStoredState.ts";
import {
	RECENT_FROM_MAILBOXES_KEY,
	rememberRecentFromMailbox,
	removeRecentFromMailbox,
} from "src/components/views/tenantMail/fromMailAddressUtils.ts";

export { RECENT_FROM_MAILBOXES_KEY } from "src/components/views/tenantMail/fromMailAddressUtils.ts";

export interface UseRecentFromMailboxesResult {
	currentUserEmail: string;
	recentFromMailboxes: string[];
	defaultFromMailbox: string;
	rememberRecentMailbox: (mailbox: string) => void;
	removeRecentMailbox: (mailbox: string) => void;
}

export const useRecentFromMailboxes = (): UseRecentFromMailboxesResult => {
	const { userEmail } = useGlobalInitData();
	const [recentFromMailboxes, setRecentFromMailboxes] = useStoredState<string[]>({
		key: RECENT_FROM_MAILBOXES_KEY,
		defaultValue: [],
		type: "array",
		separateByEnvironmentType: true,
	});

	return {
		currentUserEmail: userEmail,
		recentFromMailboxes,
		defaultFromMailbox: recentFromMailboxes[0] ?? "",
		rememberRecentMailbox(mailbox: string) {
			setRecentFromMailboxes((current) => {
				return rememberRecentFromMailbox(current, mailbox, userEmail);
			});
		},
		removeRecentMailbox(mailbox: string) {
			setRecentFromMailboxes((current) => {
				return removeRecentFromMailbox(current, mailbox);
			});
		},
	};
};
